const months = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec'
];

export function getLastUpdatedDateFormat(dateStr) {
	function pad(number) {
		if (number < 10) {
			return '0' + number;
		}
		return number;
	}
	let date = new Date(dateStr);
	return pad(date.getUTCDate()) + ' ' + months[date.getUTCMonth()] + ' ' + date.getUTCFullYear();
}

export function getMultiRegionCompanyIds() {
	const companyIdsString = process.env.REACT_APP_MULTIREGION_COMPANY_IDS;
	if (!companyIdsString) {
		return [];
	}
	return companyIdsString.split(',');
}